import styled from 'styled-components';
import { spacer, breakpoint, color } from '@spotify-internal/encore-foundation';
import { navMobileHeight, navDesktopHeight } from './variables';

export const Wrapper = styled.div`
  background: ${color.gray7};
  display: flex;
  align-items: center;
  position: relative;

  @media (max-width: ${breakpoint.screenXsMax}) {
    height: ${navMobileHeight};
    padding-right: ${spacer.spacer4};
    padding-left: ${spacer.spacer4};
    justify-content: space-between;
  }

  @media (min-width: ${breakpoint.screenSmMin}) {
    height: ${navDesktopHeight};
    padding-right: ${spacer.spacer20};
    padding-left: ${spacer.spacer20};
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${spacer.spacer24};
  }
`;
